import { callApi } from '~/services/axiosInstance.service'

import { SubscriptionPurchase } from '../types/native-app.types'

export class MobileAppApi {
  public async validateReceipt(receipt: SubscriptionPurchase): Promise<any> {
    try {
      const response = await callApi({
        url: '/v1/mobile-app/validate-purchase',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        data: { receiptinfo: receipt },
      })
      return response.data
    } catch (err) {
      throw new Error(err)
    }
  }
}

const mobileAppApi = new MobileAppApi()

export default mobileAppApi
